import { grey } from '@mui/material/colors'
import { Theme } from '@mui/material/styles'

const useStyles = {
  dataGridContainer: (theme: Theme) => ({
    width: '100%',
    marginBottom: theme.spacing(-10),
  }),
  dataGrid: (theme: Theme) => ({
    '& .MuiDataGrid-row': {
      padding: '2px 0',
    },
    '& .MuiDataGrid-cell': {
      border: 0,
      padding: theme.spacing(0, 1, 0, 1),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(0),
      },
    },
    '& .MuiDataGrid-columnHeader': {
      padding: theme.spacing(0, 1, 0, 1),
    },
    '& .MuiDataGrid-withBorderColor': {
      border: 0,
    },
    '& .MuiDataGrid-iconButtonContainer': {
      marginLeft: '2px',
      width: 'auto',
      visibility: 'visible',
    },
    '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon': {
      opacity: 0.5,
    },
    '& .MuiDataGrid-columnHeader .MuiBadge-badge': {
      display: 'none',
    },
  }),
  centeredColumnHeader: {
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      justifyContent: 'center',
    },
  },
  rightAlignedColumnHeader: {
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      justifyContent: 'flex-end',
    },
  },
  moveFolderCurrentLocationContainer: (theme: Theme) => ({
    backgroundColor: theme.palette.action.hover,
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(3),
  }),
  moveFolderNewLocationContainer: (theme: Theme) => ({
    backgroundColor: theme.palette.info.shades['4p'],
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(1.5),
  }),
  initiateIcon: {
    fontSize: '12px !important',
  },
  dialog: {
    '& .MuiDialog-paper': {
      width: '600px',
    },
  },
  processingSpinner: (theme: Theme) => ({
    marginRight: theme.spacing(1),
  }),
  optOutStepper: {
    '& .MuiStepConnector-root': {
      marginLeft: '10px',
    },
  },
  greenStep: (theme: Theme) => ({
    color: theme.palette.success.light,
  }),
  greyStep: {
    color: grey[500],
  },
  redStep: (theme: Theme) => ({
    color: theme.palette.error.main,
  }),
}

export default useStyles
